export default "__VITE_ASSET__44501d20__"